import EventEmitter from "events";

export const GlobalEvents = {
  API_REQUEST_UNAUTHORIZED: "API_REQUEST_UNAUTHORIZED",
};

export const globalEventEmitter = new EventEmitter();
